import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { useTheme, alpha } from '@material-ui/core/styles';

/** Pantalla / streaming — vector decorativo. */
export function BroadcastScreenVector({ width = 200, sx = {} }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const accent = theme.palette.secondary?.main || '#00bcd4';
  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0, ...sx }}>
      <svg width={width} height={width * 0.72} viewBox="0 0 200 144" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="12" width="184" height="108" rx="16" fill={alpha(primary, 0.12)} stroke={alpha(primary, 0.35)} strokeWidth="2" />
        <rect x="24" y="28" width="152" height="76" rx="10" fill={alpha(primary, 0.2)} />
        <path d="M108 52L128 64L108 76V52Z" fill={accent} />
        <rect x="40" y="84" width="48" height="6" rx="3" fill={alpha(primary, 0.4)} />
        <rect x="96" y="84" width="64" height="6" rx="3" fill={alpha(primary, 0.25)} />
        <circle cx="168" cy="36" r="6" fill="#ef4444" opacity="0.9" />
        <text x="164" y="39" fill="white" fontSize="7" fontWeight="700">
          LIVE
        </text>
        <path d="M4 120h192" stroke={alpha(primary, 0.2)} strokeWidth="4" strokeLinecap="round" />
        <rect x="72" y="124" width="56" height="8" rx="4" fill={alpha(primary, 0.3)} />
      </svg>
    </Box>
  );
}

BroadcastScreenVector.propTypes = {
  width: PropTypes.number,
  sx: PropTypes.object,
};

/** Ondas de señal / audio — vector decorativo. */
export function SignalWavesVector({ width = 120, sx = {} }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0, ...sx }}>
      <svg width={width} height={width * 0.85} viewBox="0 0 120 102" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="60" cy="51" r="28" fill={alpha(primary, 0.1)} stroke={alpha(primary, 0.25)} strokeWidth="2" />
        <path
          d="M60 35c-8 0-14 6-14 16 0 6 3 11 8 14"
          stroke={primary}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M60 35c8 0 14 6 14 16 0 6-3 11-8 14"
          stroke={primary}
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.5"
        />
        <path d="M36 51H24M96 51H84M60 27V15M60 87V75" stroke={alpha(primary, 0.35)} strokeWidth="2" strokeLinecap="round" />
        <circle cx="60" cy="51" r="6" fill={primary} />
      </svg>
    </Box>
  );
}

SignalWavesVector.propTypes = {
  width: PropTypes.number,
  sx: PropTypes.object,
};

/** Red de nichos conectados — vector decorativo. */
export function NicheGridVector({ width = 160, sx = {} }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const accent = theme.palette.secondary?.main || '#00bcd4';
  const nodes = [
    [32, 28],
    [88, 20],
    [128, 48],
    [100, 88],
    [40, 80],
    [72, 52],
  ];
  const edges = [
    [0, 5],
    [1, 5],
    [2, 5],
    [3, 5],
    [4, 5],
    [0, 4],
    [1, 2],
  ];
  return (
    <Box component="span" sx={{ display: 'block', lineHeight: 0, ...sx }}>
      <svg width={width} height={width} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        {edges.map(([a, b]) => (
          <line
            key={`${a}-${b}`}
            x1={nodes[a][0]}
            y1={nodes[a][1]}
            x2={nodes[b][0]}
            y2={nodes[b][1]}
            stroke={alpha(primary, 0.2)}
            strokeWidth="2"
          />
        ))}
        {nodes.map(([cx, cy], i) => (
          <g key={i}>
            <circle cx={cx} cy={cy} r={i === 5 ? 14 : 10} fill={i === 5 ? accent : alpha(primary, 0.15)} />
            <circle
              cx={cx}
              cy={cy}
              r={i === 5 ? 14 : 10}
              fill="none"
              stroke={i === 5 ? accent : primary}
              strokeWidth="2"
              opacity={i === 5 ? 1 : 0.5}
            />
          </g>
        ))}
      </svg>
    </Box>
  );
}

NicheGridVector.propTypes = {
  width: PropTypes.number,
  sx: PropTypes.object,
};
